import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['content'];

  static values = {
    closedClasses: { type: String, default: 'closed' },
    shortcutGroup: { type: String, default: 'editor' }
  }

  get closedClassList() {
    return this.closedClassesValue.split(' ').filter(Boolean);
  }

  openPanel(escapeHandler = null) {
    this.element.classList.remove('initial-state');
    this.closedClassList.forEach(cls => this.element.classList.remove(cls));

    document.dispatchEvent(new CustomEvent('promote:editor-opened'));

    document.dispatchEvent(new CustomEvent('promote:shortcuts--register', {
      detail: {
        key: 'Escape',
        group: this.shortcutGroupValue,
        handler: escapeHandler || this.closePanel.bind(this)
      }
    }));
  }

  closePanel() {
    this.closedClassList.forEach(cls => this.element.classList.add(cls));

    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = '';
    }

    document.dispatchEvent(new CustomEvent('promote:editor-closed'));

    document.dispatchEvent(new CustomEvent('promote:shortcuts--unregister', {
      detail: { group: this.shortcutGroupValue }
    }));
  }
}
